<script>
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import {
    showUpgradeModal,
    sidebarIsExpanded,
  } from "../../elements/Sidebar/stores/sidebar-store";
  import Body from "./Body.svelte";

  const onclose = () => {
    $showUpgradeModal = false;
    $sidebarIsExpanded = false;
  };
</script>

<Modal blur="4px" {onclose} closeButton={false} showHeader={false}>
  <Body />
</Modal>
